<script lang="ts">
	//UI
	//Utils
	import { getT } from "@hitit/utils";
	import { storeLogos } from "@hitit/hub/src/v7/store";
	//Types
	import type { StoreData } from "@hitit/api";
	import { selectedStoreLogo } from "../../stores";

	//Props
	export let store: StoreData;
	//Constants
	//Variables
	//Functions

	//Do
</script>

<div class="container">
	<div class="profile-box">
		<img src={$selectedStoreLogo} alt="Store Logo" />
		{#if store.storeStatus === "OPEN"}
			<div class="open-mark" />
		{/if}
		<h3>{getT(store?.translationDTOs || [], "name", "ko")}</h3>
	</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		box-sizing: border-box;
		width: calc(100% - 20px);
		padding: 10px 20px;
		background-color: #f0f0f4;
		border-radius: 0 5px 5px 0;

		.profile-box {
			position: relative;
			display: flex;
			align-items: center;
			gap: 10px;

			img {
				width: 40px;
				height: 40px;
				border-radius: 40px;
				background-color: #d8d9df;
			}

			.open-mark {
				position: absolute;
				width: 10px;
				height: 10px;
				border-radius: 5px;
				top: 0;
				left: 0;
				background-color: #44e4ee;
			}

			h3 {
				font-size: 1.25rem;
				font-weight: 550;
				color: #46474b;
				text-overflow: ellipsis;
				overflow: hidden;
			}
		}
	}

	@include DesktopSize {
		.container {
			padding: 10px 0px 10px 50px;
		}
	}
</style>
